import { createFileRoute } from '@tanstack/react-router';

import { getContactQueryOptions } from '@/_pages/contacts/api-service';
import Loading from '@/_pages/contacts/profile/loading';

export const Route = createFileRoute('/_private/contacts/_template/$id/')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getContactQueryOptions(opts.params.id)),
  staticData: {
    renderRightColumn: true,
    hasEditableHeader: true,
    pageTitle: 'Profile',
    tabKey: 'contacts/profile',
  },
  pendingComponent: Loading,
});
